<app-header></app-header>
<section class="middle-section getstarted reportsIMain">
  <div class="container-fluid" [hidden]="id">
    <div class="initiale_sestion">
      <div class="head">
        <div class="d-flex">
          <a (click)="goback()"><i class="fa fa-angle-left"></i></a>
          <h4>{{'Manage DTS reports' | translate}}</h4>
        </div>
        <button id="submit_btn" class="btn btn-main2" data-toggle="modal" data-target="#reportModal">{{'Initiate Reports'| translate}}.</button>
      </div>
    </div>
    <!-- <div class="image-container" *ngIf="!page">

               <img src="assets/images/cnss_pic.png" class="img-fluid">

                <div class="text"> {{"You haven't initiate any"| translate}}<br> {{'CNSS reports yet.'| translate}}</div>
            </div> -->
  </div>
  <div class="container-fluid" [hidden]="!id">
    <div class="initiale_sestion">
      <div class="head">
        <div class="d-flex">
          <a (click)="goback()"><i class="fa fa-angle-left"></i></a>
          <h4 class="form-title-sm">{{'Manage DTS reports'| translate}}</h4>
        </div>
      </div>
      <div *ngIf="amountToBePaidArray" class="head_2">
        <h5 *ngIf="amountToBePaidArray"> {{amountToBePaidArray.quarter}}</h5>
        <div>
         
          <!-- <h5 class="ongoingStatus"><i class="fa-solid fa-circle-exclamation"></i> {{'Not yet Submitted'| translate}}</h5> -->
          <h5 *ngIf="amountToBePaidArray.status == 0" class="pendingStatus"><i class="fa-solid fa-circle-exclamation"></i> {{'Waiting for Approval'| translate}}</h5>
          <h5 *ngIf="amountToBePaidArray.status == 6" class="payNowStatus"><i class="fa-solid fa-circle-exclamation"></i> {{'Waiting for payment'| translate}}</h5>
          <h5 *ngIf="amountToBePaidArray.status == 4" class="rejectedStatus"><i class="fa-solid fa-circle-exclamation"></i> {{'Report Rejected'| translate}}</h5>
          <h5 *ngIf="amountToBePaidArray.status == 1" class="completedStatus"><i class="fa-solid fa-check"></i>{{'Payment Completed'| translate}}</h5>
        </div>
      </div>
    </div>

    <div class="edit-btn-div expandable-section-edit" *ngIf="employerDetails?.status != 1 && cnamgsemployerDetails?.status != 1">
      <button class="report-edit-btn" (click)="editReport()"><img src="assets/images/edit-icon.png" alt="edit">{{'Edit'| translate}}</button>
    </div>


    <div class="expandable-section cnss-report-section" [ngClass]="{'open': isOpenCnssReport}">
      <div class="expandable-section-head">
        <h5>{{'CNSS Report'| translate}}</h5>
        <div class="expandable-section-icon" (click)="cnssReportExpand()">
          <img src="assets/images/cnss-logo-2.png" alt="" class="img-fluid">
          <i class="fa fa-chevron-down down-icon" [ngClass]="{'rotate-180': isOpenCnssReport}"></i>
        </div>
      </div>
      <div class="cnss_report">
        <div class="reportTable">
          <div class="rejectedNote">
            <h5>{{'Reason for rejection'| translate}}</h5>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit tempora quia, veritatis numquam laboriosam perferendis dignissimos temporibus maxime provident blanditiis culpa laborum excepturi voluptas iure officia reiciendis maiores sunt eaque ipsam, quibusdam quam ab repellat? Nobis expedita quis voluptate voluptatem quae, impedit eveniet harum facilis.</p>
          </div>
          <!-- <div class="edit-btn-div " *ngIf="employerDetails?.status != 1">
            <button class="report-edit-btn" (click)="editReport()"><img src="assets/images/edit-icon.png" alt="edit">{{'Edit'| translate}}</button>
          </div> -->
          <div class="overview">
            <div class="table_head position-relative">
              <h5 *ngIf="employerDetails">{{'Reports for'| translate}} {{employerDetails.declaration}}</h5>
             
            </div>
            <div class="container cnss_bg" *ngIf="employerDetails">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                  <ul class="sec1">
                    <li>
                      <h6 class="t1">{{'CNSS Employer ID'| translate}}&nbsp;: </h6>
                      <h6>{{employerDetails.employer_cnss}} <span *ngIf="!employerDetails.employer_cnss">--</span></h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Name'| translate}}&nbsp;: </h6>
                      <h6>{{employerDetails.name || '--'}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Post box'| translate}}&nbsp;: </h6>
                      <h6>{{employerDetails.post_box || '--'}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Cellphone No'| translate}}&nbsp;: </h6>
                      <h6>+241 {{employerDetails.mobile || '--'}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Town'| translate}}&nbsp;: </h6>
                      <h6>{{employerDetails.city || '--'}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Email'| translate}}&nbsp;: </h6>
                      <h6>{{employerDetails.email || '--'}}</h6>
                    </li>
                  </ul>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <ul class="sec2">
                    <li>
                      <h6 class="t1">{{'Date'| translate}}&nbsp;: </h6>
                      <h6>{{employerDetails.date || '--'}}</h6>
                    </li>
                    <!-- <li>
                      <h6 class="t1">{{'Net contribution due'| translate}}&nbsp;:</h6>
                      <h6>{{employerDetails.net_contribution_due}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Contribution paid to CNSS'| translate}}&nbsp;:</h6>
                      <h6>{{employerDetails.contribution_paid}}</h6>
                    </li> -->
                  </ul>
                  <div class="total_table">
                    <ul>
                      <li class="justify-content-between">
                        <h6 class="">{{'Contribution rate'| translate}}&nbsp;: </h6>
                        <h6>{{employerDetails.contribution_rate || '--'}} </h6>
                      </li>
                      <li class="justify-content-between">
                        <h6 class="t1">{{'Employer'| translate}}&nbsp;: </h6>
                        <h6>{{employerDetails.employer_rate || '--'}} </h6>
                      </li>
                      <li class="justify-content-between">
                        <h6 class="t1">{{'Worker'| translate}}&nbsp;: </h6>
                        <h6>{{employerDetails.worker_rate || '--'}} </h6>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container" *ngIf="employerDetails && employerDetails.status == '0'">
            <form>
              <table class="quarter_table" *ngFor="let report of cnssReport">
                <caption>{{'Reports for'| translate}} {{report.date}}</caption>
                <colgroup>
                  <col span="1" class="slno">
                  <col span="1" class="ccpsId">
                  <col span="1" class="cnssId">
                  <col span="1" class="nipNumber">
                  <col span="1" class="name">
                  <col span="1" class="hgDate">
                  <col span="1" class="tnDate">
                  <col span="1" class="hour">
                  <col span="1" class="wd">
                  <col span="1" class="salary">
                  <col span="1" class="cnss-salary-limit">
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">{{'#'| translate}}</th>
                    <th scope="col">{{'CCPS ID'| translate}}</th>
                    <th scope="col">{{'CNSS ID'| translate}}</th>
                    <th scope="col">{{'NIP Number'| translate}}</th>
                    <th scope="col">{{'Name'| translate}}</th>
                    <th scope="col">{{'Hiring Date'| translate}}</th>
                    <th scope="col">{{'Termination Date'| translate}}</th>
                    <th scope="col">{{'Working hours'| translate}}</th>
                    <th scope="col">{{'Working Days'| translate}}</th>
                    <th scope="col">{{'Salary1'| translate}}/{{'Month2'| translate}}(FCFA)</th>
                    <th scope="col">{{'Cnss Salary Limit'| translate}} (FCFA)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let employee of report.employees; let i = index">
                    <td attr.data-label="{{'#' | translate}}">{{i + 1}}</td>
                    <td *ngIf="!employee.ccpsid" attr.data-label="{{'CCPS ID' | translate}}">--</td>
                    <td *ngIf="employee.ccpsid" attr.data-label="{{'CCPS ID' | translate}}">{{employee.ccpsid}}</td>
                    <td *ngIf="!employee.cnssid" attr.data-label="{{'CNSS ID' | translate}}">--</td>
                    <td class="date-hiring-date" *ngIf="employee.cnssid" attr.data-label="{{'CNSS ID' | translate}}">{{employee.cnssid}}</td>
                    <td *ngIf="!employee.nip_number" attr.data-label="{{'NIP Number' | translate}}">--</td>
                    <td *ngIf="employee.nip_number" attr.data-label="{{'NIP Number' | translate}}">{{employee.nip_number}}</td>
                    <td attr.data-label="{{'Name' | translate}}">{{employee.name}}</td>
                    <td class="date-hiring-date" attr.data-label="{{'Hiring Date' | translate}}">{{employee.hiring_date}}</td>
                    <td *ngIf="!employee.termination_date" attr.data-label="{{'Termination Date' | translate}}">--</td>
                    <td *ngIf="employee.termination_date" attr.data-label="{{'Termination Date' | translate}}">{{employee.termination_date}}</td>
                    <td attr.data-label="{{'Working hours' | translate}}">{{employee.working_hour}}</td>
                    <td attr.data-label="{{'Working Days' | translate}}">{{employee.working_days}}</td>
                    <td attr.data-label="{{'Salary / Month'| translate}}">{{employee.salary}}</td>
                    <td attr.data-label="{{'Cnss Salary Limit'| translate}}">{{employee.cnss_salary_limit}}</td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
          <div *ngIf="employerDetails && employerDetails.status != '0'" class="table-container">
            <form>
              <table class="payment_table table-responsive" *ngFor="let report of cnssReport">
                <caption>{{'Reports for'| translate}} {{report.date}} </caption>
                <colgroup>
                  <col span="1" class="slno">
                  <col span="1" class="ccpsId">
                  <col span="1" class="cnssId">
                  <col span="1" class="nipNumber">
                  <col span="1" class="name">
                  <col span="1" class="hgDate">
                  <col span="1" class="tnDate">
                  <col span="1" class="wHD">
                  <col span="1" class="salary">
                  <col span="1" class="cnss-salary-limit">
                  <col span="1" class="contribution_col">
                  <col span="1" class="wcCol">
                  <col span="1" class="amount">
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">{{'#'| translate}}</th>
                    <th scope="col">{{'CCPS ID'| translate}}</th>
                    <th scope="col">{{'CNSS ID'| translate}}</th>
                    <th scope="col">{{'NIP Number'| translate}}</th>
                    <th scope="col">{{'Name'| translate}}</th>
                    <th scope="col">{{'Hiring Date'| translate}}</th>
                    <th scope="col">{{'Termination Date'| translate}}</th>
                    <th scope="col">{{'Working hours/day'| translate}}</th>
                    <th scope="col">{{'Salary / Month'| translate}}(FCFA)</th>
                    <th scope="col">{{'Cnss Salary Limit'| translate}} (FCFA)</th>
                    <th scope="col">{{'Employer Contribution'| translate}}</th>
                    <th scope="col">{{'Worker Contribution'| translate}}</th>
                    <th scope="col">{{'Gross social contributions'| translate}}</th>
                    <th scope="col">{{'Family allowances'| translate}}</th>
                    <th scope="col">{{'Net social contributions'| translate}}(FCFA)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let employee of report.employees; let i = index">
                    <td attr.data-label="{{'#' | translate}}">{{i + 1}}</td>
                    <td *ngIf="!employee.ccpsid" attr.data-label="{{'CCPS ID' | translate}}">--</td>
                    <td *ngIf="employee.ccpsid" attr.data-label="{{'CCPS ID' | translate}}">{{employee.ccpsid}}</td>
                    <td *ngIf="!employee.cnssid" attr.data-label="{{'CNSS ID' | translate}}">--</td>
                    <td class="date-hiring-date" *ngIf="employee.cnssid" attr.data-label="{{'CNSS ID' | translate}}">{{employee.cnssid}}</td>
                    <td *ngIf="!employee.nip_number" attr.data-label="{{'NIP Number' | translate}}">--</td>
                    <td *ngIf="employee.nip_number" attr.data-label="{{'NIP Number' | translate}}">{{employee.nip_number}}</td>
                    <td attr.data-label="{{'Name' | translate}}">{{employee.name}}</td>
                    <td class="date-hiring-date" attr.data-label="{{'Hiring Date' | translate}}">{{employee.hiring_date}}</td>
                    <td *ngIf="!employee.termination_date" attr.data-label="{{'Termination Date' | translate}}">--</td>
                    <td *ngIf="employee.termination_date" attr.data-label="{{'Termination Date' | translate}}">{{employee.termination_date}}</td>
                    <td data-label="Working hours/day">{{employee.working_hour}}</td>
                    <td attr.data-label="{{'Salary / Month'| translate}}">{{employee.salary}}</td>
                    <td attr.data-label="{{'Cnss Salary Limit'| translate}}">{{employee.cnss_salary_limit}}</td>
                    <td *ngIf="employee.employer_share_total" data-label="Employer Contribution">{{employee.employer_share_total}}</td>
                    <td *ngIf="!employee.employer_share_total" data-label="Employer Contribution">--</td>
                    <td data-label="Worker Contribution">{{employee.employee_share_total}}</td>
                    <td *ngIf="!employee.gross_social_contributions" data-label="Gross social contributions">--</td>
                    <td *ngIf="employee.gross_social_contributions" data-label="Gross social contributions">{{employee.gross_social_contributions}}</td>
                    <td *ngIf="!employee.family_allowances" data-label="Family allowances">--</td>
                    <td *ngIf="employee.family_allowances" data-label="Family allowances">{{employee.family_allowances}}</td>
                    
                    <td data-label="Amount">{{employee.amount}}</td>
                  </tr>
                  <tr>
                    <td class="showRows" attr.data-label="{{'#' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'CCPS ID' | translate}}"></td>
                    <td class="showRows date-hiring-date" attr.data-label="{{'CNSS ID' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'NIP Number' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'Name' | translate}}"></td>
                    <td  class="showRows date-hiring-date" attr.data-label="{{'Hiring Date' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'Termination Date' | translate}}"></td>
                    <td class="showRows" data-label="Working hours/day"></td>
                    <td attr.data-label="{{'Salary / Month'| translate}}">{{report.totalsalary}} FCFA</td>
                    <td></td>
                    <td data-label="Employer Contribution">{{report.totalemployer}} FCFA</td>
                    <td data-label="Worker Contribution">{{report.totalworker}} FCFA</td>
                    <td data-label="Gross social contributions">{{report.totalgross_social_contributions}} FCFA</td>
                    <td data-label="Family allowances">{{report.totalfamily_allowances}} FCFA</td>
                    <td data-label="Amount">{{report.totalamount}} FCFA</td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
          <div *ngIf="employerDetails " class="tableFooter2 pb-0">
            <div *ngIf="reportAllList" class="total_each">
              <h6>{{'Total Amount by Employer'| translate}} : {{reportAllList.amount_by_employer}} FCFA</h6>
              <h6>{{'Total Amount by worker'| translate}} : {{reportAllList.amount_by_worker}} FCFA</h6>
              <h6>{{'Total Salary provided'| translate}} : {{reportAllList.total_salary}} FCFA</h6>
            </div>
            <div *ngIf="reportAllList" class="total_each penalty-container">
              <h6>{{'Penalty rate for late report generation'| translate}} : {{reportAllList.total_penality_rate_to_pay}} FCFA({{reportAllList.penality_rate}})<button class="view-all" *ngIf="penaltyRate?.length >=1" data-toggle="modal" data-target="#lateDtsModal">{{ showAllDtsList ? ('View Less' | translate) : ('View More' | translate) }}</button></h6>
              <h6>{{'Penalty rate for late payment'| translate}} : {{reportAllList.total_penality_rate_for_late_payment}} FCFA({{reportAllList.penality_rate_for_late_payment}})<button *ngIf="paymentPenaltyRate?.length >=1" class="view-all" data-toggle="modal" data-target="#latePaymentModal">{{ showAllPaymentList ? ('View Less' | translate) : ('View More' | translate) }}</button></h6>
            </div>
            <!-- <div *ngIf="reportAllList" class="total_amount">
              <h4>{{'Total Amount to be paid to CNSS'| translate}} : <span>{{reportAllList.paid_to_cnss}} FCFA</span></h4>
              <h4 class="due_date m-0">{{'Due date'| translate}} : <span class="due_date">{{reportAllList.due_date}}</span></h4>
              <h4 class="due_date mt-0">{{'Payments beyond the due date will result in late payment penalties'| translate}}</h4>
              <h4 class="due_date my-0" *ngIf="penaltyRate?.length >=1">{{'You received a penalty for late reporting'| translate}}</h4>
              <h4 class="due_date mt-0" *ngIf="penaltyRate?.length >=1">{{'You received a late payment penalty'| translate}}</h4>
      
              <h4 class="due_date mt-0">{{'You had until' | translate}} <b>{{reportAllList.due_date}}</b> {{'declare and avoid the penalty equivalent to' | translate}} <b>{{reportAllList.payment_penality_rate}}%</b> {{'of the principal of the DTS.' | translate}}</h4>
            </div> -->
            <!-- <button *ngIf="reportAllList" class="btn btn-main2" (click)="paymentInitiate()">{{'Pay'| translate}} {{reportAllList.paid_to_cnss}} FCFA</button> -->
          </div>
          <!-- <div *ngIf="employerDetails && employerDetails.status == 1" class="tableFooter3">
            <div *ngIf="reportAllList" class="total_each">
              <h6>{{'Total Amount by Employer'| translate}} : {{reportAllList.amount_by_employer}} FCFA</h6>
              <h6>{{'Total Amount by worker'| translate}} : {{reportAllList.amount_by_worker}} FCFA</h6>
              <h6>{{'Total Salary provided'| translate}} : {{reportAllList.total_salary}} FCFA</h6>
            </div>
            <div *ngIf="reportAllList" class="total_each penalty-container">
              <h6>{{'Penalty rate for late report generation'| translate}} : {{reportAllList.total_penality_rate_to_pay}} FCFA({{reportAllList.penality_rate}})<button class="view-all" *ngIf="penaltyRate?.length >=1" data-toggle="modal" data-target="#lateDtsModal">{{ showAllDtsList ? ('View Less' | translate) : ('View More' | translate) }}</button></h6>
              <h6>{{'Penalty rate for late payment'| translate}} : {{reportAllList.total_penality_rate_for_late_payment}} FCFA({{reportAllList.penality_rate_for_late_payment}})<button *ngIf="paymentPenaltyRate?.length >=1" class="view-all" data-toggle="modal" data-target="#latePaymentModal">{{ showAllPaymentList ? ('View Less' | translate) : ('View More' | translate) }}</button></h6>
            </div>
            <div class="total_amount">
          
              <div>
                <h3>{{'Paid via'| translate}} <img class="payment-gateway-img" src="{{employerDetails.url}}"><i class="fa-solid fa-check"></i> <br>
                  {{'Payment Reference Number'| translate}} : {{employerDetails.reference_id}}
                </h3>
              </div>
              <div class="amount-time-container">
                <h4>{{'Total Amount paid to CNSS'| translate}} : <span>{{reportAllList.paid_to_cnss}} FCFA</span>
                </h4>
                 <h4>{{'Payment Time'| translate}} : {{employerDetails.payment_date}}
                </h4>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>


    <div  class="expandable-section cnss-report-section" [ngClass]="{'open': isOpenCnamgsReport}">
      <div class="expandable-section-head">
        <h5>{{'CNAMGS Report'| translate}}</h5>
        <div class="expandable-section-icon" (click)="cnamgsReportExpand()">
          <img src="assets/images/CNAMGS_col.png" alt="" class="img-fluid">
          <i class="fa fa-chevron-down down-icon" [ngClass]="{'rotate-180': isOpenCnamgsReport}"></i>
        </div>
      </div>
      <div class="cnamgs_report">
        <div class="reportTable">
          <div class="rejectedNote">
            <h5>{{'Reason for rejection'| translate}}</h5>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugit tempora quia, veritatis numquam laboriosam perferendis dignissimos temporibus maxime provident blanditiis culpa laborum excepturi voluptas iure officia reiciendis maiores sunt eaque ipsam, quibusdam quam ab repellat? Nobis expedita quis voluptate voluptatem quae, impedit eveniet harum facilis.</p>
          </div>
          <!-- <div class="edit-btn-div " *ngIf="cnamgsemployerDetails?.status != 1">
            <button class="report-edit-btn" (click)="editCnamgsReport()"><img src="assets/images/edit-icon.png" alt="edit">{{'Edit' | translate}}</button>
          </div> -->
          <div class="overview">
            <div class="table_head position-relative">
              <h5 *ngIf="cnamgsemployerDetails">{{'Reports for'| translate}} {{cnamgsemployerDetails.declaration}}</h5>
              
            </div>
            <div class="container cnamgs_bg" *ngIf="cnamgsemployerDetails">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-12">
                  <ul class="sec1">
                    <li>
                      <h6 class="t1">{{'CNAMGS Employer ID'| translate}}&nbsp;: </h6>
                      <h6>{{cnamgsemployerDetails.employer_cnamgs}} <span *ngIf="!cnamgsemployerDetails.employer_cnamgs">--</span></h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Name'| translate}}&nbsp;: </h6>
                      <h6>{{cnamgsemployerDetails.name}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Post box'| translate}}&nbsp;: </h6>
                      <h6>{{cnamgsemployerDetails.post_box}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Cellphone No'| translate}}&nbsp;: </h6>
                      <h6>+241 {{cnamgsemployerDetails.mobile}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Town'| translate}}&nbsp;: </h6>
                      <h6>{{cnamgsemployerDetails.city}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Email'| translate}}&nbsp;: </h6>
                      <h6>{{cnamgsemployerDetails.email}}</h6>
                    </li>
                  </ul>
                </div>
                <div class="col-lg-6 col-md-6 col-12">
                  <ul class="sec2">
                    <li>
                      <h6 class="t1">{{'Date'| translate}}&nbsp;: </h6>
                      <h6>{{cnamgsemployerDetails.date}}</h6>
                    </li>
                    <!-- <li>
                      <h6 class="t1">{{'Net contribution due'| translate}}&nbsp;:</h6>
                      <h6>{{cnamgsemployerDetails.net_contribution_due}}</h6>
                    </li>
                    <li>
                      <h6 class="t1">{{'Contribution paid to cnamgs'| translate}}&nbsp;:</h6>
                      <h6>{{cnamgsemployerDetails.contribution_paid}}</h6>
                    </li> -->
                  </ul>
                  <div class="total_table">
                    <ul>
                      <li class="justify-content-between">
                        <h6 class="">{{'Contribution rate'| translate}}&nbsp;: </h6>
                        <h6>{{cnamgsemployerDetails.contribution_rate}} </h6>
                      </li>
                      <li class="justify-content-between">
                        <h6 class="t1">{{'Employer'| translate}}&nbsp;: </h6>
                        <h6>{{cnamgsemployerDetails.employer_rate}} </h6>
                      </li>
                      <li class="justify-content-between">
                        <h6 class="t1">{{'Worker'| translate}}&nbsp;: </h6>
                        <h6>{{cnamgsemployerDetails.worker_rate}} </h6>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container" *ngIf="cnamgsemployerDetails && cnamgsemployerDetails.status == '0'">
            <form>
              <table class="quarter_table" *ngFor="let report of cnamgsReport">
                <caption>{{'Reports for'| translate}} {{report.date}}</caption>
                <colgroup>
                  <col span="1" class="slno">
                  <col span="1" class="ccpsId">
                  <col span="1" class="cnamgsId">
                  <col span="1" class="nipNumber">
                  <col span="1" class="name">
                  <col span="1" class="hgDate">
                  <col span="1" class="tnDate">
                  <col span="1" class="hour">
                  <col span="1" class="wd">
                  <col span="1" class="salary">
                  <col span="1" class="cnamgs-salary-limit">
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">{{'#'| translate}}</th>
                    <th scope="col">{{'CCPS ID'| translate}}</th>
                    <th scope="col">{{'cnamgs ID'| translate}}</th>
                    <th scope="col">{{'NIP Number'| translate}}</th>
                    <th scope="col">{{'Name'| translate}}</th>
                    <th scope="col">{{'Hiring Date'| translate}}</th>
                    <th scope="col">{{'Termination Date'| translate}}</th>
                    <th scope="col">{{'Working hours'| translate}}</th>
                    <th scope="col">{{'Working Days'| translate}}</th>
                    <th scope="col">{{'Salary1'| translate}}/{{'Month2'| translate}}(FCFA)</th>
                    <th scope="col">{{'Cnamgs Salary Limit'| translate}} (FCFA)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let employee of report.employees; let i = index">
                    <td attr.data-label="{{'#' | translate}}">{{i + 1}}</td>
                    <td *ngIf="!employee.ccpsid" attr.data-label="{{'CCPS ID' | translate}}">--</td>
                    <td *ngIf="employee.ccpsid" attr.data-label="{{'CCPS ID' | translate}}">{{employee.ccpsid}}</td>
                    <td *ngIf="!employee.cnamgsid" attr.data-label="{{'cnamgs ID' | translate}}">--</td>
                    <td *ngIf="employee.cnamgsid" attr.data-label="{{'cnamgs ID' | translate}}">{{employee.cnamgsid}}</td>
                    <td *ngIf="!employee.nip_number" attr.data-label="{{'NIP Number' | translate}}">--</td>
                    <td *ngIf="employee.nip_number" attr.data-label="{{'NIP Number' | translate}}">{{employee.nip_number}}</td>
                    <td attr.data-label="{{'Name' | translate}}">{{employee.name}}</td>
                    <td class="date-hiring-date" attr.data-label="{{'Hiring Date' | translate}}">{{employee.hiring_date}}</td>
                    <td *ngIf="!employee.termination_date" attr.data-label="{{'Termination Date' | translate}}">--</td>
                    <td *ngIf="employee.termination_date" attr.data-label="{{'Termination Date' | translate}}">{{employee.termination_date}}</td>
                    <td attr.data-label="{{'Working hours' | translate}}">{{employee.working_hour}}</td>
                    <td attr.data-label="{{'Working Days' | translate}}">{{employee.working_days}}</td>
                    <td attr.data-label="{{'Salary / Month'| translate}}">{{employee.salary}}</td>
                    <td attr.data-label="{{'Cnamgs Salary Limit'| translate}}">{{employee.cnamgs_salary_limit}}</td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
          <div *ngIf="cnamgsemployerDetails && cnamgsemployerDetails.status != '0'" class="table-container">
            <form>
              <table class="payment_table table-responsive" *ngFor="let report of cnamgsReport">
                <caption>{{'Reports for'| translate}} {{report.date}} </caption>
                <colgroup>
                  <col span="1" class="slno">
                  <col span="1" class="ccpsId">
                  <col span="1" class="cnamgsId">
                  <col span="1" class="nipNumber">
                  <col span="1" class="name">
                  <col span="1" class="hgDate">
                  <col span="1" class="tnDate">
                  <col span="1" class="wHD">
                  <col span="1" class="salary">
                  <col span="1" class="cnamgs-salary-limit">
                  <col span="1" class="contribution_col">
                  <col span="1" class="wcCol">
                  <col span="1" class="amount">
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">{{'#'| translate}}</th>
                    <th scope="col">{{'CCPS ID'| translate}}</th>
                    <th scope="col">{{'cnamgs ID'| translate}}</th>
                    <th scope="col">{{'NIP Number'| translate}}</th>
                    <th scope="col">{{'Name'| translate}}</th>
                    <th scope="col">{{'Hiring Date'| translate}}</th>
                    <th scope="col">{{'Termination Date'| translate}}</th>
                    <th scope="col">{{'Working hours/day'| translate}}</th>
                    <th scope="col">{{'Salary / Month'| translate}}(FCFA)</th>
                    <th scope="col">{{'Cnamgs Salary Limit'| translate}} (FCFA)</th>
                    <th scope="col">{{'Employer Contribution'| translate}}</th>
                    <th scope="col">{{'Worker Contribution'| translate}}</th>
                    <!-- <th scope="col">{{'Family allowances'| translate}}</th>
                    <th scope="col">{{'Gross social contributions'| translate}}</th> -->
                    <th scope="col">{{'Net social contributions'| translate}}(FCFA)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let employee of report.employees; let i = index">
                    <td attr.data-label="{{'#' | translate}}">{{i + 1}}</td>
                    <td *ngIf="!employee.ccpsid" attr.data-label="{{'CCPS ID' | translate}}">--</td>
                    <td *ngIf="employee.ccpsid" attr.data-label="{{'CCPS ID' | translate}}">{{employee.ccpsid}}</td>
                    <td *ngIf="!employee.cnamgsid" attr.data-label="{{'cnamgs ID' | translate}}">--</td>
                    <td *ngIf="employee.cnamgsid" attr.data-label="{{'cnamgs ID' | translate}}">{{employee.cnamgsid}}</td>
                    <td *ngIf="!employee.nip_number" attr.data-label="{{'NIP Number' | translate}}">--</td>
                    <td *ngIf="employee.nip_number" attr.data-label="{{'NIP Number' | translate}}">{{employee.nip_number}}</td>
                    <td attr.data-label="{{'Name' | translate}}">{{employee.name}}</td>
                    <td class="date-hiring-date" attr.data-label="{{'Hiring Date' | translate}}">{{employee.hiring_date}}</td>
                    <td *ngIf="!employee.termination_date" attr.data-label="{{'Termination Date' | translate}}">--</td>
                    <td *ngIf="employee.termination_date" attr.data-label="{{'Termination Date' | translate}}">{{employee.termination_date}}</td>
                    <td data-label="Working hours/day">{{employee.working_hour}}</td>
                    <td attr.data-label="Salary / Month">{{employee.salary}}</td>
                    <td attr.data-label="{{'Cnamgs Salary Limit'| translate}}">{{employee.cnamgs_salary_limit}}</td>
                    <td *ngIf="employee.employer_share_total" data-label="Employer Contribution">{{employee.employer_share_total}}</td>
                    <td *ngIf="!employee.employer_share_total" data-label="Employer Contribution">--</td>
                    <td data-label="Worker Contribution">{{employee.employee_share_total}}</td>
                    <!-- <td *ngIf="!employee.family_allowances" data-label="Family allowances">--</td>
                    <td *ngIf="employee.family_allowances" data-label="Family allowances">{{employee.family_allowances}}</td>
                    <td *ngIf="!employee.gross_social_contributions" data-label="Gross social contributions">--</td>
                    <td *ngIf="employee.gross_social_contributions" data-label="Gross social contributions">{{employee.gross_social_contributions}}</td> -->
                    <td data-label="Amount">{{employee.amount}}</td>
                  </tr>
                  <tr>
                    <td class="showRows" attr.data-label="{{'#' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'CCPS ID' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'cnamgs ID' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'NIP Number' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'Name' | translate}}"></td>
                    <td class="date-hiring-date" class="showRows" attr.data-label="{{'Hiring Date' | translate}}"></td>
                    <td class="showRows" attr.data-label="{{'Termination Date' | translate}}"></td>
                    <td class="showRows" data-label="Working hours/day"></td>
                    <td attr.data-label="{{'Salary / Month'| translate}}">{{report.totalsalary}} FCFA</td>
                    <td></td>
                    <td data-label="Employer Contribution">{{report.totalemployer}} FCFA</td>
                    <td data-label="Worker Contribution">{{report.totalworker}} FCFA</td>
                    <!-- <td data-label="Family allowances">{{report.totalfamily_allowances}} FCFA</td>
                    <td data-label="Gross social contributions">{{report.totalgross_social_contributions}} FCFA</td> -->
                    <td data-label="Amount">{{report.totalamount}} FCFA</td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
          <div *ngIf="cnamgsemployerDetails " class="tableFooter2 pb-0">
            <div *ngIf="cnamgsReportAllList" class="total_each">
              <h6>{{'Total Amount by Employer'| translate}} : {{cnamgsReportAllList.amount_by_employer}} FCFA</h6>
              <h6>{{'Total Amount by worker'| translate}} : {{cnamgsReportAllList.amount_by_worker}} FCFA</h6>
              <h6>{{'Total Salary provided'| translate}} : {{cnamgsReportAllList.total_salary}} FCFA</h6>
            </div>
            <div *ngIf="cnamgsReportAllList" class="total_each penalty-container">
              <h6>{{'Penalty rate for late report generation'| translate}} : {{cnamgsReportAllList.total_penality_rate_to_pay}} FCFA({{cnamgsReportAllList.penality_rate}})<button class="view-all" *ngIf="cnamgspenaltyRate?.length >=1" data-toggle="modal" data-target="#lateDtsCnamgsModal">{{ showAllCnamgsDtsList ? ('View Less' | translate) : ('View More' | translate) }}</button></h6>
              <h6>{{'Penalty rate for late payment'| translate}} : {{cnamgsReportAllList.total_penality_rate_for_late_payment}} FCFA({{cnamgsReportAllList.penality_rate_for_late_payment}})<button *ngIf="cnamgspaymentPenaltyRate?.length >=1" class="view-all" data-toggle="modal" data-target="#latePaymentCnamgsModal">{{ showAllCnamgsPaymentList ? ('View Less' | translate) : ('View More' | translate) }}</button></h6>
            </div>
      
            <!-- <div *ngIf="cnamgsReportAllList" class="total_amount">
              <h4>{{'Total Amount to be paid to CNAMGS'| translate}} : <span>{{cnamgsReportAllList.paid_to_cnamgs}} FCFA</span></h4>
              <h4 class="due_date m-0">{{'Due date'| translate}} : <span class="due_date">{{cnamgsReportAllList.due_date}}</span></h4>
              <h4 class="due_date mt-0">{{'Payments beyond the due date will result in late payment penalties'| translate}}</h4>
              <h4 class="due_date my-0" *ngIf="cnamgspenaltyRate?.length >=1">{{'You received a penalty for late reporting'| translate}}</h4>
              <h4 class="due_date mt-0" *ngIf="cnamgspenaltyRate?.length >=1">{{'You received a late payment penalty'| translate}}</h4>
              <h4 class="due_date mt-0">{{'You had until' | translate}} <b>{{cnamgsReportAllList.due_date}}</b> {{'declare and avoid the penalty equivalent to' | translate}} <b>{{cnamgsReportAllList.payment_penality_rate}}%</b> {{'of the principal of the DTS.' | translate}}</h4>
            </div> -->
            <!-- <button *ngIf="cnamgsReportAllList" class="btn btn-main2" (click)="paymentInitiateCnamgs()">{{'Pay'| translate}} {{cnamgsReportAllList.paid_to_cnamgs}} FCFA</button> -->
          </div>
          <!-- <div *ngIf="cnamgsemployerDetails && cnamgsemployerDetails.status == 1" class="tableFooter3">
            <div *ngIf="cnamgsReportAllList" class="total_each">
              <h6>{{'Total Amount by Employer'| translate}} : {{cnamgsReportAllList.amount_by_employer}} FCFA</h6>
              <h6>{{'Total Amount by worker'| translate}} : {{cnamgsReportAllList.amount_by_worker}} FCFA</h6>
              <h6>{{'Total Salary provided'| translate}} : {{cnamgsReportAllList.total_salary}} FCFA</h6>
            </div>
            <div *ngIf="cnamgsReportAllList" class="total_each penalty-container">
              <h6>{{'Penalty rate for late report generation'| translate}} : {{cnamgsReportAllList.total_penality_rate_to_pay}} FCFA({{cnamgsReportAllList.penality_rate}})<button *ngIf="cnamgspenaltyRate?.length >=1" class="view-all" data-toggle="modal" data-target="#lateDtsModal">{{ showAllCnamgsDtsList ? ('View Less' | translate) : ('View More' | translate) }}</button></h6>
              <h6>{{'Penalty rate for late payment'| translate}} : {{cnamgsReportAllList.total_penality_rate_for_late_payment}} FCFA({{cnamgsReportAllList.penality_rate_for_late_payment}})<button *ngIf="cnamgspaymentPenaltyRate?.length >=1" class="view-all" data-toggle="modal" data-target="#latePaymentModal">{{ showAllCnamgsPaymentList ? ('View Less' | translate) : ('View More' | translate) }}</button></h6>
            </div>
            <div class="total_amount">
             
              <div>
                <h3>{{'Paid via'| translate}} <img class="payment-gateway-img" src="{{cnamgsemployerDetails.url}}"><i class="fa-solid fa-check"></i> <br>
                  {{'Payment Reference Number'| translate}} : {{cnamgsemployerDetails.reference_id}}
                </h3>
              </div>
              <div class="amount-time-container">
                <h4>{{'Total Amount paid to CNAMGS'| translate}} : <span>{{cnamgsReportAllList.paid_to_cnamgs}} FCFA</span>
                </h4>
                <h4>{{'Payment Time'| translate}} : {{cnamgsemployerDetails.payment_date}}
                </h4>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>



    <div class="reportTable">
      <div *ngIf="employerDetails?.status != 1 || cnamgsemployerDetails?.status != 1" class="tableFooter2 expandable-section-table-footer">
        <div  class="total_amount">
          <h4 *ngIf="amountToBePaidArray?.paid_to_cnss">{{'Total amount to be paid to CNSS'| translate}} : <span>{{amountToBePaidArray?.paid_to_cnss}} FCFA</span></h4>
          <h4 *ngIf="amountToBePaidArray?.paid_to_cnamgs">{{'Total amount to be paid to CNAMGS'| translate}} : <span>{{amountToBePaidArray?.paid_to_cnamgs}} FCFA</span></h4>
          <!-- <h4 *ngIf="amountToBePaidArray?.total_combined">{{'Total amount to be paid'| translate}} : <span>{{amountToBePaidArray?.total_combined}} FCFA</span></h4> -->
          <h4 class="due_date m-0">{{'Due date'| translate}} : <span class="due_date color-red-txt">{{amountToBePaidArray?.due_date}}</span></h4>
          <h4 class="due_date mt-0 color-red-txt">{{'Declaration and payments beyond the due date will result in late payment penalties'| translate}}</h4>
          <h4 class="due_date my-0 color-red-txt" *ngIf="amountToBePaidArray?.late_generation">{{'You received a penalty for late reporting'| translate}}</h4>
          <h4 class="due_date mt-0 color-red-txt" *ngIf="amountToBePaidArray?.payment_status">{{'You received a late payment penalty'| translate}}</h4>
     
        </div>
        <div class="three-btn-section" *ngIf="amount_to_array">
          <button *ngIf="amount_to_array?.cnss_payment?.payment_status == 0"  class="btn three-btn" (click)="paymentInitiateDts(amount_to_array?.cnss_payment?.uuid, null, amount_to_array?.cnss_payment?.amount, null, null)">{{'Pay CNSS DTS'| translate}} {{amount_to_array?.cnss_payment?.amount}} FCFA</button>
          <button *ngIf="amount_to_array?.cnamgs_payment?.payment_status == 0" class="btn three-btn" (click)="paymentInitiateDts(null, amount_to_array?.cnamgs_payment?.uuid, null, amount_to_array?.cnamgs_payment?.amount, null)">{{'Pay CNAMGS DTS'| translate}} {{amount_to_array?.cnamgs_payment?.amount}} FCFA</button>
          <!-- <button *ngIf="amount_to_array?.combined_payment?.payment_status == 0" class="btn three-btn" (click)="paymentInitiateDts(amount_to_array?.combined_payment?.cnss_uuid, amount_to_array?.combined_payment?.cnamgs_uuid, amount_to_array?.combined_payment?.paid_to_cnss, amount_to_array?.combined_payment?.paid_to_cnamgs, amount_to_array?.combined_payment?.amount)">{{'Pay CNSS and CNAMGS DTS'| translate}} {{amount_to_array?.combined_payment?.amount}} FCFA</button> -->
        </div>
      </div>
      <div *ngIf="employerDetails?.status == 1 || cnamgsemployerDetails?.status == 1" class="tableFooter3 paid-details-loop-div">
        <div class="total_amount" *ngFor="let payment of payment_array">
          <div>
            <h3 class="invoice-h3-div">{{'Paid via'| translate}} <img class="payment-gateway-img" src="{{payment?.url}}"><i class="fa-solid fa-check"></i> 
              <div class="pdf-container" *ngIf="payment?.invoice_url"> 
                <a href="{{payment?.invoice_url}}" target="_blank"><div  class="pdf_icon"><img src="assets/images/invoice-pdf-small.png"></div></a>
              </div>
            </h3>
            <h3> {{'Payment Reference Number'| translate}} : {{payment?.reference_id}}
            </h3>
          </div>
          <div class="amount-time-container">
            <h4>{{'Total Amount paid to'| translate}} {{payment?.portal_label}} : <span>{{payment?.paid_amount}} FCFA</span>
            </h4>
            <h4>{{'Payment Time'| translate}} : {{payment?.payment_date}}
            </h4>
          </div>
        </div>
      </div>
    </div>


  </div>
  <div class="modal fade" id="successModal" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/link_success.png">
            </div>
            <div class="text-container text-center">
              <h4 class="modal-header-txt">{{'Your report has been successfully submitted.'| translate}}</h4>
              <p class="para-light">{{'review your declaration.' | translate}}</p>
              <button id="submit_btn" class="btn btn-medium" (click)="goToViewPage()">{{'Go to home'| translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- reportList -->
<app-footer></app-footer>
<div class="modal fade" id="reportModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="!page">{{'Initiate CNSS Reports'| translate}}</h5>
        <h5 class="modal-title" id="exampleModalLongTitle" *ngIf="page">{{'Initiate CNAMGS Reports'| translate}}</h5>
        <button type="button" class="close close-modal" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="parent">
          <label for="">{{'Select Year'| translate}}</label>
          <select class="form-select form-select-lg mb-3" aria-label=".form-select-lg example">
            <option value="1" selected="selected">2022</option>
            <option value="2">2023</option>
            <option value="3">2024</option>
          </select>
          <div class="parent">
            <label for="">{{'Select Quarter'| translate}}</label>
            <select class="form-select form-select-lg mb-3" aria-label=".form-select-lg example">
              <option value="1" selected>{{'One'| translate}}</option>
              <option value="2">{{'Two'| translate}}</option>
              <option value="3">{{'Three'| translate}}</option>
              <option value="4">{{'Four'| translate}}</option>
            </select>
          </div>
          <button id="submit_btn" class="btn btn-medium" (click)="showCnssList()">{{'Generate'| translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" id="lateDtsModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="form-title text-center">{{ 'Penalty rate for late report generation' | translate }}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngFor="let  lateDts of penaltyRate;" class="total_each">
          <h6>{{ lateDts.month }} {{ lateDts.year }}, {{ lateDts.amount }} FCFA ({{ lateDts.penalty}}%)</h6>
        </div>
      </div>
      <div class="modal-footer">
        <h6>{{ 'Total Amount' | translate }} :</h6>
        <h6 *ngIf="reportAllList">{{ reportAllList.total_penality_rate_to_pay}} FCFA({{reportAllList.penality_rate}})</h6>
        <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
      </div>
    </div>
  </div>
</div>
<!-- cnamgs Modal -->
<div class="modal fade" id="lateDtsCnamgsModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="form-title text-center">{{ 'Penalty rate for late report generation' | translate }}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngFor="let  lateDts of cnamgspenaltyRate;" class="total_each">
          <h6>{{ lateDts.month }} {{ lateDts.year }}, {{ lateDts.amount }} FCFA ({{ lateDts.penalty}}%)</h6>
        </div>
      </div>
      <div class="modal-footer">
        <h6>{{ 'Total Amount' | translate }} :</h6>
        <h6 *ngIf="cnamgsReportAllList">{{ cnamgsReportAllList.total_penality_rate_to_pay}} FCFA({{cnamgsReportAllList.penality_rate}})</h6>
        <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
      </div>
    </div>
  </div>
</div>
<!-- cnamgs Modal -->

<!-- Modal -->
<div class="modal fade" id="latePaymentModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="form-title text-center">{{ 'Penalty rate for late payment' | translate }}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngFor="let  paymentRate of paymentPenaltyRate;" class="total_each">
          <h6>{{ paymentRate.month }} {{ paymentRate.year }}, {{ paymentRate.amount }} FCFA ({{ paymentRate.penalty}}%)</h6>
        </div>
      </div>
      <div class="modal-footer">
        <h6>{{ 'Total Amount' | translate }} :</h6>
        <h6 *ngIf="reportAllList">{{ reportAllList.total_penality_rate_for_late_payment}} FCFA({{reportAllList.penality_rate_for_late_payment}})</h6>
        <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
      </div>
    </div>
  </div>
</div>

<!-- cnamgs Modal -->

<div class="modal fade" id="latePaymentCnamgsModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="form-title text-center">{{ 'Penalty rate for late payment' | translate }}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngFor="let  paymentRate of cnamgspaymentPenaltyRate;" class="total_each">
          <h6>{{ paymentRate.month }} {{ paymentRate.year }}, {{ paymentRate.amount }} FCFA ({{ paymentRate.penalty}}%)</h6>
        </div>
      </div>
      <div class="modal-footer">
        <h6>{{ 'Total Amount' | translate }} :</h6>
        <h6 *ngIf="cnamgsReportAllList">{{ cnamgsReportAllList.total_penality_rate_for_late_payment}} FCFA({{cnamgsReportAllList.penality_rate_for_late_payment}})</h6>
        <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
      </div>
    </div>
  </div>
</div>
<app-add-bank></app-add-bank>
<app-contact-floating></app-contact-floating>
